import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractService } from './abstract.service';
import { environment } from 'environments/environment';
import { EstadoCliente } from "app/dto/estado-cliente.dto";
import { TipoComprobante } from 'app/dto/tipo-comprobante.dto';

@Injectable({
  providedIn: 'root'
})
export class TipoComprobanteService extends AbstractService<TipoComprobante>{

  constructor(http: HttpClient) {
    super(http, environment.url_backend + 'tipo-comprobante');
  }

}
